import { render, staticRenderFns } from "./studentsEditDataMedical.vue?vue&type=template&id=6f0b1982&scoped=true"
import script from "./studentsEditDataMedical.vue?vue&type=script&lang=js"
export * from "./studentsEditDataMedical.vue?vue&type=script&lang=js"
import style0 from "./studentsEditDataMedical.vue?vue&type=style&index=0&id=6f0b1982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b1982",
  null
  
)

export default component.exports